@if (keywords.length > 0) {
  <div class="flex flex-col" aria-label="Keywords" *transloco="let t">
    <p role="heading" aria-level="2" class="mb-sm heading-base font-semibold not-italic">
      {{ t('footer.keywords') }}
    </p>
    <ul class="keyword-list col">
      @for (keyword of keywords; track keyword) {
        <li>
          <a [href]="keyword.url" bgoOpenNewTab>{{ keyword.text }}</a>
        </li>
      }
    </ul>
  </div>
}
